<template>
  <div class="bg-white dark:bg-[#2e2d38] shadow sm:rounded-lg w-full">
    <div class="px-4 py-5 sm:p-6">
      <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-white">
        {{ t("app-file") }}
      </h3>
      <div class="mt-5">
        <div
          class="px-6 py-5 rounded-md bg-gray-50 sm:flex sm:items-center sm:justify-between"
        >
          <h4 class="sr-only">pdf</h4>
          <div class="sm:flex sm:items-center">
            <DocumentDownloadIcon class="w-8 h-8" />
            <div class="mt-3 sm:mt-0 sm:ml-4">
              <div class="text-base font-medium text-gray-900">
                {{ t("personal-networth") }}
              </div>
            </div>
          </div>
          <div class="mt-4 sm:mt-0 sm:ml-6 sm:flex-shrink-0">
            <button
              @click="download"
              type="button"
              class="inline-flex items-center px-4 py-2 font-medium text-white bg-green-600 border border-gray-300 rounded-md shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:text-sm"
            >
              {{ t("download") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { computed } from "vue";
import { DocumentDownloadIcon } from "@heroicons/vue/outline";

export default {
  name: "FIleIoPdfComponent",
  components: { DocumentDownloadIcon },
  props: {
    id: {
      type: Number,
      required: true,
    },
    pdf: {
      type: Object,
      default: {},
    },
  },
  setup(props) {
    const { t } = useI18n();
    const url = computed(() => props.pdf[t("locale")]);

    const download = async () => {
      if (url.value) {
        window.open(url.value, "_blank");
      }
    };

    return {
      t,
      download,
      url,
    };
  },
};
</script>
